import styled from 'styled-components'
import { FormControlWrapper } from '../FormControlWrapper'
import { GBIcon } from '../VehicleReg/styles'
import { UppercaseInputStyled } from '../common/Input/UppercaseInput'
export const RegistrationInput = styled(UppercaseInputStyled)`
  font-family: ${(props) => props.theme.regFont};
  color: ${({ theme }) => theme.primaryTextColour};
  letter-spacing: 1px;
  font-size: 32px;
  line-height: 48px;
  text-align: center;
  border-radius: ${(props) => props.theme.formControlBorderRadius};
  border: 1px solid ${(props) => props.theme.inputBorderColour};
  box-sizing: border-box;
  ::placeholder {
    letter-spacing: 0;
    font-family: ${(props) => props.theme.fontFamily};
    font-size: 23px;
    line-height: 48px;
  }
  @media (min-width: 768px) {
    line-height: 58px;
    ::placeholder {
      line-height: 58px;
    }
  }
`

export const RegistrationWrapper = styled(FormControlWrapper)`
  text-align: center;
`

export const ChangeVehicleGBIcon = styled(GBIcon)`
  line-height: 50px;
  @media (min-width: 768px) {
    line-height: 60px;
  }
`
